import { render, staticRenderFns } from "./PatientEpisodeDropdown.vue?vue&type=template&id=67d382f6&scoped=true&"
import script from "./PatientEpisodeDropdown.vue?vue&type=script&lang=js&"
export * from "./PatientEpisodeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d382f6",
  null
  
)

export default component.exports